if (!customElements.get('nb-addons')) {
  class NBAddons extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('[js-addon]');
      this.button = this.querySelector('[js-addon-button]');
      this.dropdown = this.querySelector('[js-addon-dropdown]');
      this.options = this.querySelectorAll('[js-addon-option]');

      this.init();
    }

    init() {
      // Handle button click
      this.button.addEventListener('click', () => {
        const isOpen = this.button.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      });

      // Handle keyboard events on combobox container
      this.container.addEventListener('keydown', (event) => {
        const isOpen = this.container.getAttribute('aria-expanded') === 'true';
        
        if (event.key === 'Escape' && isOpen) {
          event.preventDefault();
          this.closeDropdown();
        } else if ((event.key === 'Enter' || event.key === ' ') && !isOpen) {
          event.preventDefault();
          this.openDropdown();
        } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!isOpen) {
            this.openDropdown();
          } else {
            this.navigateOptions(event.key === 'ArrowDown' ? 1 : -1);
          }
        }
      });

      // Handle keyboard events on options
      this.options.forEach((option) => {
        option.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' || event.key === 'Enter') {
            const isOpen = this.button.getAttribute('aria-expanded') === 'true';
            if (isOpen) {
              event.preventDefault();
              this.closeDropdown();
            }
          }
        });

        // Handle click events on options
        option.addEventListener('click', () => {
          const isOpen = this.button.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            this.selectOption(option);
            this.closeDropdown();
          }
        });
      });

      // Handle clicks outside
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          const isOpen = this.container.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            this.closeDropdown();
          }
        }
      });
    }

    navigateOptions(direction) {
      const checkedOption = this.querySelector('[js-addon-option]:checked');
      const allOptions = Array.from(this.options);
      const currentIndex = allOptions.indexOf(checkedOption);
      const newIndex = Math.max(0, Math.min(allOptions.length - 1, currentIndex + direction));
      
      if (newIndex !== currentIndex) {
        allOptions[newIndex].checked = true;
        allOptions[newIndex].dispatchEvent(new Event('change', { bubbles: true }));
        this.updateSelectedOption(allOptions[newIndex]);
      }
    }

    selectOption(option) {
      option.checked = true;
      option.dispatchEvent(new Event('change', { bubbles: true }));
      this.updateSelectedOption(option);
    }

    updateSelectedOption(option) {
      // Update aria-selected states
      this.querySelectorAll('[role="option"]').forEach(opt => {
        opt.setAttribute('aria-selected', 'false');
      });
      const optionContainer = option.closest('[role="option"]');
      if (optionContainer) {
        optionContainer.setAttribute('aria-selected', 'true');
      }
      
      // Update displayed selection
      const selectedDisplay = this.querySelector('[js-addon-selected-option]');
      if (!selectedDisplay) return;
      
      // Find the label associated with this option
      const label = this.querySelector(`label[for="${option.id}"]`);
      if (!label) return;
      
      // Get the title from the label
      const titleElement = label.querySelector('.nb-addons-label-title .nb-body-copy-12-medium');
      const title = titleElement ? titleElement.textContent : option.value;
      const image = option.dataset.image;
      
      let html = '';
      if (image) {
        html += `<span class='nb-addon-selected-option-image'><img src="${image}" /></span>`;
      }
      html += `<span>${title}</span>`;
      const priceDisplay = option.dataset.priceDisplay;
      if (priceDisplay) {
        html += `<span class='nb-addon-selected-option-price'>${priceDisplay}</span>`;
      }
      selectedDisplay.innerHTML = html;
    }

    openDropdown() {
      this.button.setAttribute('aria-expanded', 'true');
      this.container.setAttribute('aria-expanded', 'true');
      this.dropdown.removeAttribute('hidden');
    }

    closeDropdown() {
      this.button.setAttribute('aria-expanded', 'false');
      this.container.setAttribute('aria-expanded', 'false');
      this.dropdown.setAttribute('hidden', '');
      this.container.focus();
    }
  }

  customElements.define('nb-addons', NBAddons);
}
